module.exports = {
  URDF_SPHERE: 0,
  URDF_BOX: 1,
  URDF_CYLINDER: 2,
  URDF_MESH: 3
};